<div class="item">
  <div>{{ label() }}</div>
  <div>
    @if (service.valid()) {
      {{ value() | number: '1.0-0' : 'fr' }} kr
    } @else {
      -
    }
  </div>
</div>